import React from 'react';
import { resetpassword } from '../dbconnector/connector';
import { setErrorMessage } from "../tools/errorhandling";
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom'




const Reset = (props) => {
    const navigate = useNavigate()
    const t = props.translation
    const onBack = () => {
        navigate("/");
    }

    function performreset(e) {
        e.preventDefault();
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");
        const newPassword = document.getElementById("newPassword").value;
        if (!token) {
            setErrorMessage(t("error_tokenmissing"));
        }
    
        if (!newPassword) {
            setErrorMessage(t("message_enterpwd"));
        }
    
        try {
            resetpassword(token, newPassword).then((response) => {
                if (response.status === 200) {
                    setErrorMessage(t("message_pwd_reset_ok"));
                } else {
                    setErrorMessage(response.statusText);
                }
            });
        } catch (err) {
            setErrorMessage(t("error_passwordreset"));
        }
    }
    
    return (
        <div id="main" className="Screendiv">

            <header>
                <div id="errordiv" className='error'></div>
            </header>
            <center>
            <div id="content">
                <form className="pwdResetform" onSubmit={performreset} >
                <label className='formtitle'>{t("requestnewpwd")}</label>
                    <div className="pwdResetformchild">
                        <label className='labelhotel'>
                            {t("Paswoord")}:
                        </label>
                        <input id="newPassword" name="newPassword" className="normalinput" type='password' ></input>
                    </div>
                    <div className="two_Buttons">                        
                        <Button id="Back" type='Button' className='Savebutton' onClick={() => onBack()} >{t("Back")}</Button>
                        <Button id="passwordresetButton" type="submit" className='Savebutton' >{t("sendrequest")}</Button>
                    </div>
                </form>
            </div>
            </center>
        </div>
    );
}
export default Reset;
